import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAirtableComponent } from './simple-icons-airtable.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAirtableComponent ],
    exports:      [ SimpleIconsAirtableComponent ],
    bootstrap:    []
})
export class SimpleIconsAirtableModule {}
